// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"f2c74285","498":"2b6f8192","513":"240368b6"}[chunkId] + ".chunk.js";
};